import { MessageService, type Chat, type Message, type UpdateMessageData } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessageUpdate = () => {
  const { send: updateMessage } = useFetchComposable(
    ({
      chatId,
      messageId,
      content,
    }: {
      chatId: Chat['id'];
      messageId: Message['id'];
      content: NonNullable<UpdateMessageData['body']>;
    }) => MessageService.updateMessage({ path: { id: chatId, messageId }, body: content }),
  );

  return { updateMessage };
};

export { useMessageUpdate };
